import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ITimelineEntryWithData } from "@app/directives/_veri/v-timeline/v-timeline.component";
import { DateService } from "@app/services/date.service";
import { TranslationService } from "@app/services/translation.service";
import { ITemperatureOutOfBoundsHistory } from "@temperature/_models/temperature/ITemperatureOutOfBoundsHistory";
import { ITemperatureProbeWithTemperatureData } from "@temperature/_models/temperature/ITemperatureProbe";
import { Observable } from "rxjs";
import { IZoneWithProbes } from "../_models/temperature/ITemperatureZone";
import { IZoneTemperatureOutOfBoundsHistory } from "../_models/temperature/ITemperatureZoneOutOfBoundsHistory";

@Injectable({ providedIn: 'root' })
export class TemperatureOutOfBoundsHistoryService {
    constructor(private readonly http: HttpClient,
        private readonly dateService: DateService,
        private readonly translationService: TranslationService) { }

    getActiveVehicleTemperatureOutOfBoundsHistories(): Observable<ITemperatureOutOfBoundsHistory[]> {
        return this.http.get<ITemperatureOutOfBoundsHistory[]>(`/api/temperature/outOfBoundsHistories/active`);
    }

    getVehicleTemperatureOutOfBoundsHistories(vehicleId: number, start: Date | string, end: Date | string): Observable<ITemperatureOutOfBoundsHistory[]> {
        const params = {
            vehicleId: vehicleId,
            start: new Date(start).toISOString(),
            end: new Date(end).toISOString(),
        }
        return this.http.get<ITemperatureOutOfBoundsHistory[]>(`/api/temperature/outOfBoundsHistories/${vehicleId}`, { params: params });
    }

    getVehicleTemperatureOutOfBoundsHistory(historyId: number): Observable<ITemperatureOutOfBoundsHistory> {
        return this.http.get<ITemperatureOutOfBoundsHistory>(`/api/temperature/outOfBoundsHistory/${historyId}`);
    }

    getVehicleTemperatureOutOfBoundsHistoryByAlarmRecord(alarmId: number): Observable<ITemperatureOutOfBoundsHistory> {
        return this.http.get<ITemperatureOutOfBoundsHistory>(`/api/temperature/outOfBoundsHistoryByAlarm/${alarmId}`);
    }

    getAllVehicleTemperatureOutOfBoundsHistories(start: Date | string, end: Date | string): Observable<ITemperatureOutOfBoundsHistory[]> {
        const params = {
            start: new Date(start).toISOString(),
            end: new Date(end).toISOString(),
        }
        return this.http.get<ITemperatureOutOfBoundsHistory[]>(`/api/temperature/outOfBoundsHistories`, { params: params });
    }

    mapHistoriesToProbe(outOfBoundsHistories: ITemperatureOutOfBoundsHistory[], probe: ITemperatureProbeWithTemperatureData) {
        probe.outOfBoundsHistories = outOfBoundsHistories.filter(history => history.TemperatureProbeId === probe.Id);
    }

    createTimelineEntriesForOutOfBoundsHistory(outOfBoundsHistory: IZoneTemperatureOutOfBoundsHistory[], zones: IZoneWithProbes[], historyStartTime: Date): ITimelineEntryWithData<number>[] {
        const timelineEntries: ITimelineEntryWithData<number>[] = [];

        outOfBoundsHistory.forEach(history => {
            const zoneNumber = zones.find(zone => zone.Id === history.ZoneId)?.Position;
            if (this.dateService.date1IsAfterDate2(history.StartTime, historyStartTime)) {
                timelineEntries.push({
                    icon: "warning",
                    date: history.StartTime as any,
                    largeDetails: {
                        title: this.translationService.t("ReeferDetail.ZoneOutOfBounds", zoneNumber)
                    },
                    data: history.ZoneId
                });
            }

            if (history.EndTime) {
                timelineEntries.push({
                    icon: "check",
                    date: history.EndTime as any,
                    largeDetails: {
                        title: this.translationService.t("ReeferDetail.ZoneBackInBounds", zoneNumber)
                    },
                    data: history.ZoneId
                });
            }
        })

        return timelineEntries;
    }
}
